import { makeAutoObservable } from 'mobx';

export default class ViewSettingsStore {
    detailsPanelState: DetailsPanelState = DetailsPanelState.Left;
    isDetailsFullScreen: boolean = false;
    isPopupExpanded: boolean = false;
    isMobile: boolean;

    constructor() {
        makeAutoObservable(this);
        this.isMobile = this.getDefaultIsMobile();
    }

    toggleIsDetailsFullScreen() {
        this.isDetailsFullScreen = !this.isDetailsFullScreen;
    }

    toggleDetailsPanelState() {
        this.detailsPanelState = this.detailsPanelState === DetailsPanelState.Left ? DetailsPanelState.Bottom : DetailsPanelState.Left;
        this.isDetailsFullScreen = false;
    }

    setIsPopupExpanded(value: boolean) {
        this.isPopupExpanded = value;
    }

    setIsMobile(value: boolean) {
        this.isMobile = value;
    }

    getDefaultIsMobile(): boolean {
        return /Android|iPhone|iPad|iPod|Windows Phone|Mobile/i.test(navigator.userAgent);
    }

    clear() {
        this.detailsPanelState = DetailsPanelState.Left;
        this.isDetailsFullScreen = false;
        this.setIsPopupExpanded(false);
        this.isMobile = this.getDefaultIsMobile();
    }
}

export enum DetailsPanelState {
    Left = "Left",
    Bottom = "Bottom",
}